import React from 'react';
import { Container, Typography, Paper } from '@mui/material';

const TermsOfService: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
            <Paper elevation={0} sx={{ p: 4, borderRadius: 2 }}>
                <Typography variant="h3" gutterBottom fontWeight="bold" color="primary">Terms of Service</Typography>
                <Typography variant="caption" display="block" gutterBottom>Last Updated: January 2026</Typography>

                <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>1. Acceptance of Terms</Typography>
                <Typography variant="body1" paragraph>
                    By accessing and using this platform, you agree to be bound by these Terms of Service.
                </Typography>

                <Typography variant="h6" gutterBottom>2. User Conduct</Typography>
                <Typography variant="body1" paragraph>
                    You agree to use the platform for lawful educational purposes only. Any misuse or disruption of the service is prohibited.
                </Typography>

                <Typography variant="h6" gutterBottom>3. Disclaimer</Typography>
                <Typography variant="body1" paragraph>
                    The content provided is for educational support and does not replace official school curriculum or assessments.
                </Typography>
            </Paper>
        </Container>
    );
};
export default TermsOfService;
